// src/components/SearchResults.jsx
import React from 'react';
import Item from './Item';
import { useItemFilters } from '../hooks/useItemFilters';

const SearchResults = ({
  searchTerm,
  allItems,
  onAddToList,
  onEditItem,
  onDeleteItem,
  onQuantityChange,
  onCheckToggle,
  onChangeList,
  onUpdateItem, // NUEVA PROP
  showToast,
  availableCategories,
  activeList,
  activeListId,
  lists,
  context // 'list' o 'catalog'
}) => {
  const { filterItemsBySearch } = useItemFilters();
  
  // Filtrar items según el término de búsqueda
  const filteredItems = filterItemsBySearch(allItems, searchTerm);
  
  // Si no hay término de búsqueda, no mostrar nada
  if (!searchTerm.trim()) {
    return (
      <div className="p-8 text-center text-gray-500 pointer-events-none">
        <i className="fas fa-search text-gray-300 text-6xl mx-auto mb-4 block"></i>
        <p className="text-gray-600">Type something to search</p>
      </div>
    );
  }

  // Si no hay resultados
  if (filteredItems.length === 0) {
    return (
      <div className="p-8 text-center text-gray-500 pointer-events-none ">
        <div className="mb-6">
          <i className="fas fa-search text-gray-300 text-6xl mx-auto mb-4 block"></i>
          <p className="mb-2">No items found matching "{searchTerm}"</p>
          <p className="text-sm text-gray-600">
            Click the "Add" button above to create it
          </p>
        </div>
      </div>
    );
  }

  // Hay resultados - mostrarlos
  return (
    <div className="divide-y divide-gray-100">
      {filteredItems.map(item => {
        const hasList = item.list_id !== null && item.list_id !== undefined;
        const isUnchecked = parseInt(item.status) === 0;
        const inList = hasList && isUnchecked;

        return (
          <div 
            key={item.id}
            className="bg-white hover:bg-gray-50 transition-colors"
          >
            <Item
              item={item}
              isInList={inList}
              showDaysSince={!inList}
              onCheckToggle={onCheckToggle}
              onDelete={onDeleteItem}
              onEdit={onEditItem}
              onQuantityChange={onQuantityChange}
              onAddToList={() => onAddToList(item.id)}
              onChangeList={inList ? onChangeList : undefined}
              onUpdateItem={onUpdateItem} // NUEVA PROP
              showToast={showToast}
              availableCategories={availableCategories}
              currentView="search"
              activeList={activeList}
              activeListId={activeListId}
              lists={lists}
            />
          </div>
        );
      })}
    </div>
  );
};

export default SearchResults;